import { useUserStore } from '@/stores/user';
import { SESSION_DISABLE_TIME } from './constant';

export const isDisabledDueToTimeout = () => {
  const session = useUserStore.getState().validateSession;
  if (session?.status === 'FAILED' && session?.time) {
    const currentTime = new Date();
    const userTime = new Date(session.time);
    const timeDifference = currentTime.getTime() - userTime.getTime();
    return timeDifference < SESSION_DISABLE_TIME;
  }
  return false;
};

// Helper to parse time string in HH:MM AM/PM or HH:MM duration format
export const parseTime = (timeStr: string | null | undefined): Date | undefined => {
  if (!timeStr) return undefined;

  // Duration format (HH:MM) — used for waiting time
  const durationMatch = timeStr.match(/^(\d{1,2}):(\d{2})$/);
  if (durationMatch) {
    const hours = parseInt(durationMatch[1], 10);
    const minutes = parseInt(durationMatch[2], 10);
    if (hours > 23 || minutes > 59) return undefined;
    const date = new Date();
    date.setHours(hours, minutes, 0, 0);
    return date;
  }

  // Try standard ISO-like concatenation first
  const isoTry = new Date(`1970-01-01T${timeStr}`);
  if (!isNaN(isoTry.getTime())) return isoTry;

  // Try AM/PM format
  const match = timeStr.match(/(\d{1,2}):(\d{2})\s*(AM|PM)/i);
  if (match) {
    const [, h, m, ap] = match;
    let hours = parseInt(h, 10);
    const minutes = parseInt(m, 10);
    const isPM = ap.toUpperCase() === 'PM';

    if (isPM && hours < 12) hours += 12;
    if (!isPM && hours === 12) hours = 0;

    const date = new Date();
    date.setHours(hours, minutes, 0, 0);
    return date;
  }

  return undefined;
};

// Normalizes email list input (array or comma-separated string) into a clean string array
export const normalizeEmailList = (input: unknown): string[] => {
  if (Array.isArray(input)) {
    return input
      .filter((email): email is string => typeof email === 'string')
      .map((email) => email.trim())
      .filter(Boolean);
  }
  if (typeof input !== 'string') return [];
  return input
    .split(',')
    .map((email) => email.trim())
    .filter(Boolean);
};
